import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, Button, useTheme } from '@mui/material'
import { CloseRounded, Delete } from '@mui/icons-material'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { formsStyles } from '../../../../shared/styles/FormsStyles'
import { deleteOffer } from '../../../../../redux/actions/offers'
import { CancelButton, DeleteButton } from '../../../../shared/components/inputs'

interface DeleteOfferDialogProps {
  open: boolean
  offerId: number | false
  onClose: () => void
}

const DeleteOfferDialog = ({ open, offerId, onClose }: DeleteOfferDialogProps) => {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const theme = useTheme()
  const classes = formsStyles(theme)
  const dispatch = useDispatch()

  const handleConfirmDelete = () => {
    if (offerId !== false) {
      dispatch(deleteOffer(offerId))
    }
    onClose()
  }

  return (
    <Dialog
      open={open}
      fullWidth={true}
      fullScreen={isMobile}
      maxWidth={isMobile ? undefined : 'sm'}
      sx={classes.containerForm}
      onClose={onClose}
      aria-labelledby="delete-offer-dialog-title"
      aria-describedby="delete-offer-dialog-description"
    >
      <DialogTitle id="delete-offer-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">
            {t('delete')} {t('document')}
          </Typography>
          <Button onClick={onClose} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={classes.bodyForm}>
        <Grid container alignItems="flex-start" spacing={2}>
          <Grid item xs={12}>
            <Typography>{t('admin.offers.delete-offer-text')}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={onClose}>{t('cancel')}</CancelButton>
        <DeleteButton autoFocus id="btn-handleldelete" endIcon={<Delete />} onClick={handleConfirmDelete}>
          {t('delete')}
        </DeleteButton>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteOfferDialog
